/**
 * Created by stonewang on 2017/8/18.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import { Form, Input, Select, Button, Row, Col, Checkbox, message, Table } from 'antd';
import { DmsTab, RegionCascader, SelectRange } from 'Components';
import { orgList } from '../../service/org/index';
import {add, detail, update, getLocalList, deleteLocal, updateLocal} from '../../service/inventory/house';
import {nameValidator,checkCode,checkNumber,checkPhone} from '../../utils/regexp.js';
import {showSpin,hideSpin} from 'Utils';
const FormItem = Form.Item;

class AddHouse extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      id: parseInt(this.props.params.id, 10),
      options: [],
      orgList: [],
      detail: {},
      postFlag: false,
      huowei: [],
      orgIdIndex: '', //所属组织的列表索引
      localParam: {
        storageId: parseInt(this.props.params.id, 10),
        p: 1,
        s: 100000
      },
      selectedKeys: [], // 选中辐射区域ID
      selectedNodes: [] // 选中辐射区域
    }
    this.getDetail = this.getDetail.bind(this);
    this.getLocals = this.getLocals.bind(this);
    this.addNewLine = this.addNewLine.bind(this);
    this.deleteLine = this.deleteLine.bind(this);
  }

  //发布范围相关
  handleOk = (keys, nodes) => {
    const areaText = nodes.map(x => x.name).join(';');
    this.setState({
      visible: false,
      selectedKeys: keys,
      selectedNodes: nodes
    });
    this.props.form.setFieldsValue({
      'areaText': areaText
    });
  }
  openModal () {
    this.selectRangModal.showModal();
  }

  componentWillMount () { //准备数据
    const self = this;
    orgList().then(res => { //所属组织
      if (res.data && res.data.length > 0) {
        let arr = res.data.filter(x => x.type === 1).map((x, index) => {
          return {
            ...x,
            text: x.name,
            value: x.id + ''
          }
        });
        let orgIdIndex = arr.findIndex(x => x.type === 1); //控制所属组织的数量，只显示品牌商
        orgIdIndex = orgIdIndex === -1 ? '' : arr[orgIdIndex].value;
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ orgList: arr, orgIdIndex }, () => {
              if (self.state.id > 0) {
                self.getDetail();
              }
            });
          }
        }, 0);
      }
    });
  }

  componentDidMount () {
    this.mounted = true;
    if (this.state.id > 0) {
      //this.getDetail();
      this.getLocals();
    }
  }

  getDetail () {
    const self = this;
    detail(self.state.id).then(res => {
      if (res.status) {
        let data = res.data;
        let areaTextArr = data.storageAreaList.map(x => x.areaName);
        data.areaText = areaTextArr.join(';');
        self.setState({
          'selectedKeys': data.storageAreaList.map(x => (x.areaId + '')),
          'selectedNodes': data.storageAreaList.map(x => {
            return { 'key': x.areaId, 'name': x.areaName }
          })
        });
        self.setState({detail: data, postFlag: data.localFlag ? true : false});
      }
    })
  }

  getLocals () {
    const self = this;
    getLocalList(self.state.localParam).then(res => {
      if (res.status) {
        const list = res.data;
        let arr = [];
        list.forEach(item => {
          arr.push({
            index: Math.random(),
            id: item.id,
            code: item.code,
            desc: item.desc,
            active: item.active ? true : false,
          });
        })
        self.setState({ huowei: arr });
      }
    })
  }

  cancelHandle () {
    hashHistory.goBack()
  }

  submitHandle () {
    const self = this;
    const { validateFields, getFieldsValue } = this.props.form;
    const { selectedKeys } = this.state;

    validateFields((errors) => {//表单校验
      if (errors) {
        return
      }//表单校验有误，则不执行下面的代码
      const data = {
        ...getFieldsValue() //获取用户输入
      };
      let storageLocalList = self.state.huowei.map(item => {
        let obj = {
          ...item,
          code: item.code,
          desc: item.desc,
          active: item.active ? 1 : 0,
        }
        delete obj.index;
        return obj;
      });
      let result = {
        ...data,
        ...data.adminDiv.value,
        areaIdList: selectedKeys.map(x => parseInt(x, 10)),
        localFlag: data.localFlag ? 1 : 0,
        active: data.active,
        orgId: parseInt(data.orgId, 10)
      }
      if (data.adminDiv.value) {
        result = {
          ...result,
          ...data.adminDiv.value,
        }
      } else {
        result = {
          ...result,
          ...data.adminDiv,
        }
      }
      delete result.adminDiv; //删除冗余数据
      // console.log(`你正在提交数据：${JSON.stringify(result)}`);
      showSpin();
      if (self.state.id > 0) {
        delete result.orgId;
        update({ ...result, storageLocalList, id: self.state.id }).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && hashHistory.goBack()
        })
      } else {
        add({ ...result, storageLocalList }).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && hashHistory.goBack()
        })
      }
    })
  }

  deleteLine (index) {
    const self = this;
    const { huowei, id } = this.state;
    if(id>0 && huowei[index].id){
      deleteLocal({id: huowei[index].id}).then(res => {
        message[res.status ? 'success' : 'error'](res.message);
        if(res.status){
          huowei.splice(index, 1);
          self.setState({ ...this.state, huowei });
        }
      })
    }else{
      huowei.splice(index, 1);
      this.setState({ ...this.state, huowei });
    }
  }

  addNewLine (e) {
    e.preventDefault();
    e.stopPropagation();
    const { huowei } = this.state;
    const obj = {
      index: Math.random(),
      code: '',
      desc: '',
      active: true,
    }
    this.setState({ ...this.state, huowei: [...huowei, obj] })
  }

  infoChange (index, name, e) {
    const { huowei, id } = this.state;
    let list = [...huowei];
    if(id>0 && list[index].id && name=== 'active'){
      updateLocal({id: list[index].id, active: e.target.checked ? 1 : 0}).then(res => {
        message[res.status ? 'success' : 'error'](res.message);
        if(res.status){
          let obj = {
            ...list[index],
            active: e.target.checked
          };
          list.splice(index, 1, obj);
          this.setState({ huowei: list });
        }
      })
    } else {
      let obj = {
        ...list[index],
        [name]: name === 'active' ? e.target.checked : e.target.value
      };
      list.splice(index, 1, obj);
      this.setState({ huowei: list });
    }
  }

  render () {
    const self = this;
    const { detail, huowei, postFlag, id, orgList, orgIdIndex, selectedKeys, selectedNodes } = this.state;
    const { getFieldDecorator } = this.props.form;
    /* 生成区域树
    const loop = data => data.map((item, key) => {
      if (item.children && item.children.length) {
        return <TreeSelect.TreeNode key={`${item.key}`} value={`${item.key}`} title={item.label}>{loop(item.children)}</TreeSelect.TreeNode>;
      }
      return <TreeSelect.TreeNode key={`${item.key}`} value={`${item.key}`} title={item.label} />;
    });*/
    const tableProps = {
      rowKey: 'index',
      columns: [
        {
          title: '序号',
          width: '60px',
          className: 'alignCenter',
          render: (text, record, index) => index + 1
        }, {
          title: '货位编号',
          dataIndex: 'code',
          width: '20%',
          render: (text, record, index) => {
            return <Input value={text} onChange={this.infoChange.bind(this, index, 'code')}/>
          }
        }, {
          title: '货位描述',
          dataIndex: 'desc',
          width: '40%',
          render: (text, record, index) => {
            return <Input value={text} onChange={this.infoChange.bind(this, index, 'desc')}/>
          }
        }, {
          title: '启用',
          dataIndex: 'active',
          width: '10%',
          render: (text, record, index) => {
            return <Checkbox checked={text} onChange={this.infoChange.bind(this, index, 'active')}/>
          }
        }, {
          title: '操作',
          dataIndex: '',
          className: 'alignCenter',
          render: (text, record, index) => <a onClick={this.deleteLine.bind(this, index)} style={{ color: '#d61418' }}>删除</a>
        },
      ],
      dataSource: huowei
    };
    return <div className="dms-body">
      <DmsTab options={[`${id > 0 ? '编辑' : '新建'}仓库`]} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col className="gutter-row" span={8}>
              <FormItem label="仓库名称：" hasFeedback>
                {getFieldDecorator('name', {
                  initialValue: detail.name || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入仓库名称'
                    },
                    {
                      validator: nameValidator
                    }
                  ],
                })(<Input placeholder="请输入仓库名称"/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={4}>
              <FormItem label={null} style={{ marginTop: '30px' }}>
                {getFieldDecorator('localFlag', {
                  valuePropName: 'checked',
                  initialValue: detail.localFlag ? true : false,
                  rules: [
                    {
                      required: false,
                      message: ''
                    },
                  ],
                  getValueFromEvent: (e) => {
                    self.setState({
                      postFlag: e.target.checked,
                    });
                    if (!e || !e.target) {
                      return e;
                    }
                    const { target } = e;
                    return target.type === 'checkbox' ? target.checked : target.value;
                  }
                })(<Checkbox
                >启用货位</Checkbox>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="仓库编码：" hasFeedback>
                {getFieldDecorator('code', {
                  initialValue: detail.code || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入仓库编码'
                    },
                    {
                      validator: checkCode
                    }
                  ],
                })(<Input placeholder="请输入仓库编码"/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="仓库面积(m²)：" hasFeedback>
                {getFieldDecorator('acreage', {
                  initialValue: detail.acreage || '',
                  rules: [
                    {
                      required: false,
                    },
                    {
                      validator: checkNumber
                    }
                  ],
                })(<Input/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="状态：" hasFeedback>
                {getFieldDecorator('active', {
                  initialValue: detail.active && detail.active !== null ? detail.active + '' : '1',
                  rules: [
                    {
                      required: false,
                      message: '请选择状态'
                    },
                  ],
                })(<Select allowClear style={{ width: '100%' }} placeholder="请选择状态">
                  <Select.Option key="0" value="0">失效</Select.Option>
                  <Select.Option key="1" value="1">有效</Select.Option>
                </Select>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="联系人：" hasFeedback>
                {getFieldDecorator('contacts', {
                  initialValue: detail.contacts || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入联系人姓名'
                    },
                    {
                      validator: nameValidator
                    }
                  ],
                })(<Input placeholder="请输入联系人姓名"/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="联系电话：" hasFeedback>
                {getFieldDecorator('contactsMobile', {
                  initialValue: detail.contactsMobile || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入联系电话'
                    },
                    {
                      validator: checkPhone
                    }
                  ],
                })(<Input placeholder="请输入联系电话"/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <div id="adminDivBox">
                <FormItem label="仓库地址：" hasFeedback>
                  {getFieldDecorator('adminDiv', id > 0 ? {
                    initialValue: {
                      province: detail.province ? parseInt(detail.province, 10) : '',
                      city: detail.city ? parseInt(detail.city, 10) : '',
                      county: detail.county ? parseInt(detail.county, 10) : '',
                    },
                    rules: [
                      {
                        required: true,
                        message: '请选择仓库地址'
                      },
                    ]
                  } : {
                    rules: [
                      {
                        required: true,
                        message: '请选择仓库地址'
                      },
                    ]
                  })(<RegionCascader containerId="adminDivBox" placeholder="请选择仓库地址" style={{ width: '100%' }}/>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <FormItem label={null} hasFeedback>
                {getFieldDecorator('address', {
                  initialValue: detail.address || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入仓库详细地址'
                    },
                  ]
                })(<Input placeholder="详细地址" style={{ width: '100%' }}/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="辐射区域：" hasFeedback>
                {getFieldDecorator('areaText', {
                  initialValue: detail.areaText || '',
                  rules: [
                    {
                      required: true,
                      message: '请选择辐射区域'
                    },
                  ]
                })(
                  <Input placeholder="请选择辐射区域" onClick={this.openModal.bind(this)}/>
                )}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <div id="orgIdBox">
                {
                  id > 0 && <FormItem label="所属组织：" hasFeedback>
                    <Input value={detail.orgText} disabled={true} placeholder="所属组织" style={{ width: '100%' }}/>
                  </FormItem>
                }
                {
                  id === 0 && <FormItem label="所属组织：" hasFeedback>
                    {getFieldDecorator('orgId', orgIdIndex ? {
                      initialValue: orgIdIndex.toString(),
                      rules: [
                        {
                          required: true,
                          message: '请选择所属组织'
                        },
                      ],
                    } : {
                      rules: [
                        {
                          required: true,
                          message: '请选择所属组织'
                        },
                      ],
                    })(<Select
                      allowClear
                      style={{ width: '100%' }}
                      placeholder="请选择所属组织"
                      getPopupContainer={() => document.getElementById('orgIdBox')}
                    >
                      {
                        orgList.map((item, index) => {
                          return <Select.Option key={index + ''} value={item.value}>{item.name}</Select.Option>
                        })
                      }
                    </Select>)}
                  </FormItem>
                }
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      <SelectRange ref={(node) => {this.selectRangModal = node;}}
                   keys={selectedKeys}
                   nodes={selectedNodes}
                   onOk={this.handleOk.bind(this)} />
      {
        postFlag ? <div className="dms-split-bar"></div> : ''
      }
      {
        postFlag ? <DmsTab className="white-bg no-border" options={['货位']} defaultKey={0}>
          <Button icon="plus" onClick={this.addNewLine}>添加行</Button>
        </DmsTab> : ''
      }
      {
        postFlag ? <div className="dms-table-box">
          <Table {...tableProps} bordered pagination={false}/>
        </div> : ''
      }
    </div>
  }
}
export default Form.create()(AddHouse)


// WEBPACK FOOTER //
// ./src/routes/inventory/addHouse.js